import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var receivedGlobalError = function receivedGlobalError(error) {
  return {
    type: "ERRORS/GLOBAL_ERROR_RECEIVED",
    payload: {
      error: {
        displayMessage: error.displayMessage
      }
    }
  };
};
export var dismissError = function dismissError() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch({
              type: "ERRORS/ERROR_DISMISSED"
            });
            return _context.abrupt("return", new Promise(function (resolve) {
              context.window.setTimeout(function () {
                dispatch({
                  type: "ERRORS/WAIT_TIME_ELAPSED"
                });
                resolve();
              }, 1000);
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};